<template>
  <el-dialog
      title="新增预约投保单"
      :visible.sync="visible"
      class="create-policy-dialog my-dialog-template"
      width="520px"
      center
    >
      <el-form
        ref="form"
        :model="formData"
        class="my-form-template full"
        label-width="130px"
        :inline="true"
      >
        <el-form-item label="投保产品" prop="productId" :rules="$tools.formRule.required('请输入姓名')">
          <el-select 
            style="width:100%"
            filterable
            clearable 
            v-model="formData.productId" 
            @change="getAreaData"
            placeholder="搜索产品"> 
            <el-option v-for="(bean,i) in productList" :key="i" :label="bean.productName" :value="bean.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投保区域" prop="insureArea" :rules="$tools.formRule.arrRequired('请选择投保区域')">
          <el-select v-if="areaType==1" style="width:100%" v-model="formData.insureArea" placeholder="请选择">
            <el-option v-for="(item,i) in areaColumns" :key="i" :label="item" :value="item"></el-option>
          </el-select>
          <el-cascader v-if="areaType==2" style="width:100%" v-model="formData.insureArea" :options="areaColumns" :props="{label:'name',value:'name'}"></el-cascader>
          <div class="info-text">您可以选择户籍、工作或家庭住址所在的省份作为投保区域</div>
        </el-form-item>
        <el-form-item label="投保人姓名" prop="holderName" :rules="$tools.formRule.required('请输入投保人姓名')">
          <el-input
            type="text"
            placeholder="请输入"
            v-model="formData.holderName"
          ></el-input>
        </el-form-item>
        <el-form-item label="投保人身份证号" prop="holderIdCard" 
          :rules="[$tools.formRule.required('请输入投保人身份证号'),$tools.formRule.idCard('投保人身份证号格式有误')]">
          <el-input
            type="text"
            placeholder="请输入"
            v-model="formData.holderIdCard"
          ></el-input>
        </el-form-item>
        <el-form-item label="投保人手机号" prop="holderMobile" 
          :rules="[$tools.formRule.required('请输入投保人手机号'),$tools.formRule.tel('投保人手机号格式有误')]">
          <el-input
            type="text"
            placeholder="请输入"
            v-model="formData.holderMobile"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="sgCode.includes(formData.productCode)" label="是否含身故" prop="productInfo" :rules="$tools.formRule.required('请选择是否含身故')">
          <el-radio-group v-model="formData.productInfo">
            <el-radio label="含身故">含身故</el-radio>
            <el-radio label="不含身故">不含身故</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="bzqCode.includes(formData.productCode)" label="保障期限" prop="productInfo" :rules="$tools.formRule.required('请选择保障期限')">
          <el-radio-group v-model="formData.productInfo">
            <el-radio label="保至70岁">保至70岁</el-radio>
            <el-radio label="保终身">保终身</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="ldNameCode.includes(formData.productCode)" label="代理人姓名" prop="productInfo">
          <el-input type="text" placeholder="请输入" v-model="formData.productInfo"></el-input>
        </el-form-item>
        <div class="modal-info-text" v-if="ldNameCode.includes(formData.productCode)">
          <span>如果您已预约双录、可以备注代理人的姓名，我们将优先安排代理人为您双录</span>
        </div>
        <div class="modal-info-text" v-if="infoCode.includes(formData.productCode)&&formData.insureArea=='河南'">
          <span>因监管需要，投保过程中需要上传人身投保提示书及投保人签字时的照片，请您提前下载</span>
          <span class="btn right" @click="download('https://file.fxyf99.com/product_material/20220421T0KD6a.pdf')">人身投保提示书</span>
          <span>打印签字，同时在投保人签字时进行拍照</span>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button type="primary" plain @click="visible=false">取消</el-button>
        <el-button type="primary" @click="submit()" :loading="loading">确定</el-button>
      </div>
    </el-dialog>
</template>

<script>
export default {
  props: {
  },
  data: () => ({
    sgCode:["01027","01013","01035"],//需要显示身故的产品
    bzqCode:["01022"],//需要显示保障期的产品
    ldNameCode: ['01066'], //需要显示代理人姓名的产品
    areaType:1,
    infoCode:["01022","01024","01025","01026","01027","01028","01030"],//需要显示提示的产品
    fileFalg:false,//判断文件是否下载
    areaColumns:[],//区域选项
    visible:false,
    loading:false,
    formData:{
      insureArea:[]
    },
    userInfo:{},
    productList:[],
  }),
  created() {
    this.userInfo = this.$tools.getLocal("userinfo");
  },
  methods: {
    open(){
      this.visible = true;
      this.searchPorduct();
      this.$refs['form']&&this.$refs['form'].clearValidate();
    },
    // 下载文件
    download(url){
      this.fileFalg=true;
      let base = location.origin;
      if(this.$config.env == 2){//本地
        base = "https://fqyf.wts9999.net"
      }
      location.href= base+"/api/common/downloadByUrl?url="+url;
    },
    //获取区域数据
    getAreaData(proId){
      const productBase = this.productList.find((item)=>{
        return proId == item.id;
      })
      this.$set(this.formData, "insureArea", "");
      if(!productBase){
        this.areaColumns = [];
        this.areaType = 1;
        this.$set(this.formData, "productCode", "");
        return;
      }
      this.$set(this.formData, "productCode", productBase.productNo);
      console.log(productBase)
      this.$http({
        type: "GET",
        // url: "/insure/queryInsureArea",
        url: "/insure/queryCustomInsureArea2",
        params: {
          productCode:productBase.productNo,
          mechanId:this.userInfo.mechanId,
        },
      }).then((resData) => {
        const data = resData.data
        this.areaType = data.type;
        if(data.type==1&&data.area){
          this.areaColumns = data.area.split(",");
        }else if(data.type==2&&data.area){
          this.areaColumns = data.area;
        }else{
          this.areaColumns = [];
        }
      });
    },
    searchPorduct(name){
      this.$http({
        type: "PUT",
        url: "/master/product/getProductList",
        params: {
          status: "2",
          appointInsure: "1",
          pageNum: 1,
          pageSize: 999
        },
      }).then((resData) => {
        this.productList = resData.data;
      })
    },
    submit(){
      this.$refs['form'].validate(valid=>{
        if(valid){
          // 判断是否需要验证文件下载
          if(this.infoCode.includes(this.formData.productCode) && this.formData.insureArea=='河南'){
            if(!this.fileFalg){
              this.$message.error("请下载投保提示书");
              return;
            }
          }
          if(this.loading) {
            return;
          }
          this.loading = true;
          this.formData.mechanId = this.userInfo.mechanId;
          this.formData.source = "4";
          const params = JSON.parse(JSON.stringify(this.formData));
          if(this.areaType==2){
            params.insureArea = params.insureArea.join('');
          }
          this.$http({
            type: "put",
            url: "/master/appointInsure/update",
            params: params,
          }).then((resData) => {
            this.formData = {};
            this.$emit("success");
            this.visible = false;
            this.$message.success("提交成功")
          }).finally((e) => {
            this.loading = false;
          });
        }
      })
    }
  },
  
};
</script>

<style lang='scss' scoped>
.create-policy-dialog {
  .info-text {
    color: #888;
    margin-top: 5px;
    font-size: 12px;
    text-align: justify;
    line-height: 1.5;
  }
  .modal-info-text {
    font-size: 14px;
    line-height: 1.5;
    color: #AA7745;
    padding: 12px 15px;
    background-color: #FFF8F2;
    border-radius: 4px;
    margin-top: -5px;
    margin-bottom: 25px;
    .text {
      display: block;
    }
    .btn {
      color: #167aff;
      margin-left: 5px;
      text-decoration: underline;
      margin-right: 5px;
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
      &:active {
        opacity: 0.7;
      }
    }
  }
}
</style>